import '@hotwired/turbo-rails'
import * as ActiveStorage from '@rails/activestorage'
import '../controllers'

ActiveStorage.start()

// Persist theme across all Turbo navigations (runs before CSS paint on each page)
function applyTheme() {
  try {
    const theme = localStorage.getItem('pm-theme') || 'light'
    document.documentElement.dataset.theme = theme
  } catch (e) {}
}

applyTheme()
document.addEventListener('turbo:before-render', (e) => {
  try {
    const theme = localStorage.getItem('pm-theme') || 'light'
    e.detail.newBody.closest('html')?.setAttribute('data-theme', theme)
  } catch (e) {}
  applyTheme()
})
document.addEventListener('turbo:render', applyTheme)
